import React, { useState } from "react";
import MainImage from "../assets/MainImage.jpg";
import Footer from "../components/Footer";
import NavLite from "../components/NavLite";
import { db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

function Contact() {
  <main>
  <title>Contact Zilker Web Design | Start Your Web Design or SEO Project | Zilker Web Design</title>
<meta
name="description"
content="Have a project in mind? Let’s talk! Contact our team to explore custom website design and SEO solutions built for women-led brands."
/>
<meta
name="keywords"
content="connect with a women-led agency, start your growth journey, contact a web team for women, get in touch for SEO support, consult for web design services, reach out to Zilker Web Design, work with a women-first brand agency, high-end website design texas, premium web design services, austin custom website development, conversion-focused web design, mobile responsive web design austin, website design for coaches, ux/ui website design austin, brand-first website design, premium branding website texas, website design for consultants, creative web design agency austin, bespoke web development texas, web design for personal brands austin, austin expert wordpress designer, strategic website design for leads, lead generation web design austin, custom web graphics austin, lightning-fast websites austin tx, mobile-first web design texas, expert website builder for women entrepreneurs, website design for experts texas, web designer for thought leaders, seo-ready website builds, visually engaging websites texas, ux design for female-led businesses"
/>
</main>
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "",
    brief: "",
    timestamp: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add current timestamp
    const currentTimestamp = Timestamp.fromDate(new Date());
    
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        timestamp: currentTimestamp, // Add timestamp to the form data
      });

      setSubmitted(true);
      setFormData({ name: "", email: "", service: "", brief: "", timestamp: "" });
      setShowModal(true); // Show the success modal
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
  };

  return (

    <main>
    <title>Contact Us Zilker Web Design: Web Design & SEO for Women-Owned Businesses | Get a Free SEO Review | Zilker Web Design</title>
<meta
name="description"
content="Elevate your women-owned law, consulting, or finance business with expert web design and SEO. We specialize in custom websites and strategic SEO to boost your online visibility, attract ideal clients, and achieve #1 Google rankings. Schedule your free website and SEO review today!"
/>
<meta
name="keywords"
content="web design for women entrepreneurs, brand and web design, website design for creatives, affordable web design, website design for mompreneurs, branding website design, website templates wordpress, consulting website template, best life coaching websites, coaching website, service website template, life coach website template, business website templates free, website designer near me, freelance web designer near me, web design company in houston texas, web design companies in austin tx, austin web design, austin seo expert, austin seo company, law firm website development, law firm web design, law firm seo, lawyer website, law firm website design, law firm websites, law firm website, best law firm websites, best law firm seo companies, websites for lawyers, attorney websites, seo for law firms, law sites, law website designs, marketing agency for small law firms, contact woaom, web design women owned, SEO women owned business, women business website, law firm web design women, consulting website women, finance web design women, women business SEO services, website design for women, digital marketing women owned, online visibility women business, free website review women business, women business contact, austin web design women, seo for women business, website review for lawyers, website review for consultants, website review for finance, contact web design, contact seo services"
/>
    <section>
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%", // Make sure the div takes full width
        }}
      >

     <NavLite/>
        <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
          <div className="flex items-center justify-center">
            <h1 className="bg-[#CFF098] text-black italic text-3xl max-w-40">
              Contact US
            </h1>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <div className="grid items-center gap-8 sm:gap-20 md:grid-cols-2">
          <div className="max-w-3xl">
            <h2 className="mb-2 text-3xl font-bold md:text-5xl italic uppercase">
              LET’S{" "}
              <span className="bg-[#CFF098] text-black italic">DO THIS</span>
            </h2>
            <p className="my-4 max-w-lg pb-4 text-sm text-gray-200 sm:text-base md:mb-6 lg:mb-8">
              For questions or just to say hi, please feel free to reach out
              here or email us directly at info@zilkerwebdesign.com.
              <br />
              <br />
              Or, just skip that part and{" "}
              <a href="/" className="underline">
                schedule an intro call!
              </a>
            </p>
            <h5 className="text-xl mb-5 bg-[#CFF098] text-black italic max-w-[280px]">
              Contact Zilker Web Design
            </h5>
            <ul className="space-y-2 text-white">
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:hello@theboutiquecoo.com" className="">
                  info@zilkerwebdesign.com
                </a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href="tel:+15033890185" className="">
                  (737) 304-5965
                </a>
              </li>
              <li>
                <strong>Address:</strong> 1422 Collier St, Austin, TX 78704
              </li>
            </ul>
            <div className="flex">
              <div className="flex flex-col">
                <div className="mb-8 mt-6 flex flex-row">
                  <a
                    href="/"
                    className="mr-4 text-white transition hover:text-gray-400"
                  >
                    <svg
                      className="fill-current"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 2.25C9.4791 2.25005 7.05619 3.22647 5.23968 4.97439C3.42317 6.72231 2.35426 9.10586 2.25723 11.6249C2.1602 14.1439 3.0426 16.6026 4.71928 18.4851C6.39595 20.3676 8.73657 21.5275 11.25 21.7214V14.2501H9C8.80109 14.2501 8.61032 14.1711 8.46967 14.0304C8.32902 13.8898 8.25 13.699 8.25 13.5001C8.25 13.3012 8.32902 13.1104 8.46967 12.9698C8.61032 12.8291 8.80109 12.7501 9 12.7501H11.25V10.5001C11.2509 9.70472 11.5673 8.94218 12.1297 8.37977C12.6921 7.81736 13.4546 7.501 14.25 7.50009H15.75C15.9489 7.50009 16.1397 7.57911 16.2803 7.71976C16.421 7.86041 16.5 8.05118 16.5 8.25009C16.5 8.449 16.421 8.63977 16.2803 8.78042C16.1397 8.92107 15.9489 9.00009 15.75 9.00009H14.25C13.8523 9.00054 13.471 9.15872 13.1898 9.43993C12.9086 9.72114 12.7505 10.1024 12.75 10.5001V12.7501H15C15.1989 12.7501 15.3897 12.8291 15.5303 12.9698C15.671 13.1104 15.75 13.3012 15.75 13.5001C15.75 13.699 15.671 13.8898 15.5303 14.0304C15.3897 14.1711 15.1989 14.2501 15 14.2501H12.75V21.7214C15.2634 21.5275 17.604 20.3676 19.2807 18.4851C20.9574 16.6026 21.8398 14.1439 21.7427 11.6249C21.6457 9.10587 20.5768 6.72232 18.7603 4.9744C16.9438 3.22649 14.5209 2.25006 12 2.25Z"></path>
                    </svg>
                  </a>
                  <a
                    href="/"
                    className="mx-4 text-white transition hover:text-gray-400"
                  >
                    <svg
                      className="fill-current"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"></path>
                      <path d="M16.125 2.625H7.875C6.4831 2.62658 5.14865 3.18021 4.16443 4.16443C3.18021 5.14865 2.62658 6.4831 2.625 7.875V16.125C2.62658 17.5169 3.18021 18.8513 4.16443 19.8356C5.14865 20.8198 6.4831 21.3734 7.875 21.375H16.125C17.5169 21.3734 18.8513 20.8198 19.8356 19.8356C20.8198 18.8513 21.3734 17.5169 21.375 16.125V7.875C21.3734 6.4831 20.8198 5.14865 19.8356 4.16443C18.8513 3.18021 17.5169 2.62658 16.125 2.625ZM12 16.5C11.11 16.5 10.24 16.2361 9.49993 15.7416C8.75991 15.2471 8.18314 14.5443 7.84254 13.7221C7.50195 12.8998 7.41283 11.995 7.58647 11.1221C7.7601 10.2492 8.18868 9.44736 8.81802 8.81802C9.44736 8.18868 10.2492 7.7601 11.1221 7.58647C11.995 7.41283 12.8998 7.50195 13.7221 7.84254C14.5443 8.18314 15.2471 8.75991 15.7416 9.49993C16.2361 10.24 16.5 11.11 16.5 12C16.4987 13.1931 16.0241 14.3369 15.1805 15.1805C14.3369 16.0241 13.1931 16.4987 12 16.5ZM16.875 8.25C16.6525 8.25 16.435 8.18402 16.25 8.0604C16.065 7.93679 15.9208 7.76109 15.8356 7.55552C15.7505 7.34995 15.7282 7.12375 15.7716 6.90552C15.815 6.68729 15.9222 6.48684 16.0795 6.3295C16.2368 6.17217 16.4373 6.06502 16.6555 6.02162C16.8738 5.97821 17.1 6.00049 17.3055 6.08564C17.5111 6.17078 17.6868 6.31498 17.8104 6.49998C17.934 6.68499 18 6.9025 18 7.125C18 7.42337 17.8815 7.70952 17.6705 7.9205C17.4595 8.13147 17.1734 8.25 16.875 8.25Z"></path>
                    </svg>
                  </a>
                  {/* <a href="https://www.linkedin.com/company/the-boutique-coo" target="_blank" rel="noopener noreferrer" className="text-white transition hover:text-gray-400 flex items-center ">
          <svg className="fill-current" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.98 3.5c0 1.38-1.12 2.5-2.5 2.5S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.04 8.04h4.88v15.96H.04V8.04zM8.34 8.04h4.68v2.18h.06c.65-1.23 2.23-2.53 4.6-2.53 4.92 0 5.83 3.24 5.83 7.45v8.86h-4.88v-7.85c0-1.87-.04-4.27-2.6-4.27-2.6 0-3 2.03-3 4.13v7.99H8.34V8.04z"/>
            </svg>
        </a> */}
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto max-w-xl bg-[#F7F3F2] p-8 text-center">
            <h3 className="text-2xl font-bold md:text-3xl text-black">
              Stop Losing Clients,{" "}
              <span className="bg-[#CFF098] text-black italic"> Rank #1</span>{" "}
              on Google With Us!
            </h3>
            <p className="mx-auto mb-6 mt-4 max-w-lg text-sm text-gray-600 md:mb-8">
              Our clients dominate search results and attract more premium
              clients.
            </p>
            {submitted ? (
                <p className="bg-[#CFF098] text-black italic font-bold">Thank you! We'll be in touch soon.</p>
              ) : (
            <form
              className="mx-auto mb-4 max-w-sm text-left text-black" onSubmit={handleSubmit} 
              name="wf-form-password"
              method="get"
            >
              <div>
                <label
                  htmlFor="name-2"
                  className="mb-1 font-medium bg-[#CFF098] text-black italic"
                >
                  Your Name
                </label>
                <input
                  type="text"
                  name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                  className="mb-4 block h-9 w-full rounded-md border border-solid border-black px-3 py-6 pl-4 text-sm text-black"
                />
              </div>
              <div className="mb-2">
                <label
                  htmlFor="email"
                  className="mb-1 font-medium bg-[#CFF098] text-black italic"
                >
                  Email Address
                </label>
                <input
                  type="text"
                  name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                  className="mb-4 block h-9 w-full rounded-md border border-solid border-black px-3 py-6 pl-4 text-sm text-black"
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="services"
                  className="mb-1 font-medium bg-[#CFF098] text-black italic"
                >
                  Services
                </label>
                <select className="mb-4 block h-9 w-full rounded-md border border-solid border-black px-3 text-sm text-black"name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                    >
                  <option value="">Select a Service</option>
                      <option value="Web Design">Web Design (Starter, Growth and Premium Packages)</option>
                      <option value="SEO">SEO Optimization Packages</option>
                      <option value="Custom">Custom Projects/Other</option>
                </select>
              </div>
              <div className="mb-5 md:mb-6 lg:mb-8">
                <label
                  htmlFor="field-3"
                  className="mb-1 font-medium bg-[#CFF098] text-black italic"
                >
                  Project Brief
                </label>
                <textarea
                  placeholder=""
                  name="brief"
                      value={formData.brief}
                      onChange={handleChange}
                      required
                  className="mb-2.5 block h-auto min-h-32 w-full rounded-md border border-solid border-black p-3 text-sm text-black"
                ></textarea>
              </div>
              <input
                type="submit"
                value="Start Project Now"
                disabled={submitted}
                className="mb-4 inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black shadow-sm"
              />
            </form>
          )}
          </div>
        </div>
      </div>

       {/* Modal for success message */}
       {showModal && (
          <div className="fixed inset-0 flex justify-center items-center z-50 bg-black bg-opacity-50">
            <div className="bg-white p-8 rounded-lg text-center max-w-lg">
              <h2 className="text-2xl font-bold bg-[#CFF098] text-black italic">Thank You!</h2>
              <p className="mt-4 text-lg text-gray-700">
                Your service request has been submitted successfully. We'll be in touch in a few hours!
              </p>
              <button
                onClick={handleCloseModal}
                className="mt-6 bg-[#CFF098] text-black px-6 py-2 rounded-full"
              >
                Close
              </button>
            </div>
          </div>
        )}
      <Footer />
    </section>
    </main>
  );
}

export default Contact;
